import moment from "moment";
import { useTranslation } from "react-i18next";

import { DriverInfoBlock } from "../../DriverInfoBlock";
import { DriverMainInfoProps } from "./DriverMainInfo.types";

import styles from "./DriverMainInfo.module.scss";

const DriverMainInfo = ({ driverDetails }: DriverMainInfoProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.mainInfo}>
      <DriverInfoBlock
        title={t("Phone Number")}
        data-testid="driverInfo--phoneNumber"
      >
        {driverDetails.phoneNumber}
      </DriverInfoBlock>
      <DriverInfoBlock title={t("Date of Birth")} data-testid="driverInfo--dob">
        {moment(driverDetails.birthdate).format("DD/MM/YYYY")}
      </DriverInfoBlock>
      <DriverInfoBlock title={t("Address")} data-testid="driverInfo--address">
        {driverDetails.address}
      </DriverInfoBlock>

      <DriverInfoBlock
        title={t("Delivery Zones")}
        data-testid="driverInfo--deliveryZones"
      >
        <div className={styles.mainInfo_deliveryZones}>
          {driverDetails.deliveryZones.map((deliveryZone) => (
            <span key={deliveryZone.id}>
              {deliveryZone.neighborhood}, {deliveryZone.city},{" "}
              {deliveryZone.country}
            </span>
          ))}
        </div>
      </DriverInfoBlock>
    </div>
  );
};

export default DriverMainInfo;
